import { ReportTableTab } from '../TrainingReports.types';
import {
	ReportTabDefinition,
	RowStatus,
	RowStatusPresentation
} from './TrainingTable.types';

export const DEFAULT_TABLE_TAB = ReportTableTab.Users;

export const REPORT_TABS: ReportTabDefinition[] = [
	{
		key: ReportTableTab.Users,
		label: 'Users',
		icon: 'users',
		searchPlaceholder: 'Search users...'
	},
	{
		key: ReportTableTab.Assignments,
		label: 'Assignments',
		icon: 'assignmentsFilterIcon',
		searchPlaceholder: 'Search assignments...'
	},
	{
		key: ReportTableTab.Courses,
		label: 'Courses',
		icon: 'indiCoursesOutline',
		searchPlaceholder: 'Search courses...'
	}
];

export const ROW_STATUS_PRESENTATION: Record<
	RowStatus,
	RowStatusPresentation
> = {
	[RowStatus.Complete]: { label: 'Complete', tone: 'primary' },
	[RowStatus.Incomplete]: { label: 'Incomplete', tone: 'default' },
	[RowStatus.Overdue]: { label: 'Overdue', tone: 'warning' },
	[RowStatus.NotStarted]: { label: 'Not Started', tone: 'default' }
};

export const COURSE_STATUS_PRESENTATION: Record<
	RowStatus,
	RowStatusPresentation
> = {
	[RowStatus.Complete]: { label: 'Completed', tone: 'primary' },
	[RowStatus.Incomplete]: { label: 'In Progress', tone: 'default' },
	[RowStatus.Overdue]: { label: 'Overdue', tone: 'warning' },
	[RowStatus.NotStarted]: { label: 'Not Started', tone: 'default' }
};

/** Same statuses as the table, relabelled for assignments. Tones unchanged. */
export const ASSIGNMENT_STATUS_PRESENTATION: Record<
	RowStatus,
	RowStatusPresentation
> = {
	...ROW_STATUS_PRESENTATION,
	[RowStatus.Complete]: { label: 'Completed', tone: 'primary' },
	[RowStatus.Incomplete]: { label: 'In Progress', tone: 'default' }
};

/** The two values the Courses tab's "Required" column reports. */
export const COURSE_TYPE = {
	Required: 'Required',
	Optional: 'Optional'
} as const;

export const COURSE_TYPES: string[] = [
	COURSE_TYPE.Required,
	COURSE_TYPE.Optional
];

export const COURSE_DETAILS_DRAWER_WIDTH = 640;
/** Participant rows a property section shows before "View all". */
export const COURSE_USERS_PREVIEW_COUNT = 10;
export const COURSE_USER_COLUMNS = ['User', 'Status', 'Due'];
export const COURSE_ASSIGNMENTS_TITLE = 'Included in Assignments';
export const COURSE_DETAILS_EMPTY_TEXT = 'No one is enrolled at this property';

export const ASSIGNMENT_DETAILS_DRAWER_WIDTH = 640;
/** Participant rows a course table shows before "View all". */
export const ASSIGNMENT_USERS_PREVIEW_COUNT = 10;
export const ASSIGNMENT_USER_COLUMNS = ['User', 'Status', 'Due'];
export const ASSIGNMENT_COURSES_EMPTY_TEXT =
	'This assignment has no courses yet';

export const USER_DETAILS_DRAWER_WIDTH = 640;
export const USER_DETAILS_DATE_FORMAT = 'M/D/YY';
export const USER_DETAILS_COURSE_COLUMNS = ['Course', 'Status', 'Due'];
export const USER_DETAILS_EMPTY_TEXT = 'No courses assigned at this property';

/** Widths below which each tab's table scrolls sideways rather than clipping. */
export const TABLE_MIN_WIDTH: Record<ReportTableTab, number> = {
	[ReportTableTab.Users]: 1100,
	[ReportTableTab.Assignments]: 1260,
	[ReportTableTab.Courses]: 1240
};

export const EXPAND_COLUMN_WIDTH = 48;

export const DEFAULT_PAGE_SIZE = 25;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const PAGINATION_BOUNDARY_COUNT = 2;
export const PAGINATION_SIBLING_COUNT = 1;

export const ROWS_PER_PAGE_LABEL = 'Rows per page';
export const DETAILS_LABEL = 'Details';

export const TABLE_EMPTY_TEXT = 'No records match the selected filters';

export const REPORT_SEARCH_DEBOUNCE_MS = 300;
export const REPORT_DETAIL_PAGE_SIZE = 1000;
export const UNKNOWN_VALUE = '-';
